import { API } from '../../api';
import { COLLATE_DATA_MANAGER, STRONG_DATA_MANAGER } from '../../data';
import { MIX, UTILS } from '../../utils';

export default {
    namespaced: true,
    state: {
        userInfo: {
            f_name: '',
            sex: 0,
        },
        showMyVip: false,
        showVipPayPop: false,
        curVipPayType: 2, //2默认, 3文化大使, 4新年特价
        curSelectPayType: 20, //10月会员, 20年会员(默认), 30终身会员
        showVipSucPop: false,
        vipActivityInfo: {},
        showYearVipBtn: true,
        vipActivityDayLuckInfo: {},
        vipDayLuckType: 0,
        vipDayLuckInfo: {},
        vipYearUpInfo: {},
        vipYearUpTimeSecond: 300,   //倒计时时间
        vipYearUpTimeStr: '05:00',  //倒计时时间
        vipYearUpTimeFunc: null,    //倒计时函数
        showActDayLuckPop: false,
        areaStr: '',
        birthdayStr: '',
        strongUserInfo: {
            f_name: '',
            sex: 0,
            birthday: '',
            location: '',
            real_time: 0,
        },
        inputData: {
            unknownTime: false,
            isLunar: false,
            year: '', 
            month: '', 
            day: '', 
            hour: '', 
            minute: ''
        },
        timeCurrent: true,
    },
    mutations: {},
    actions: {
        getUserInfo({state}, params) {
            API.getUserInfo({
                id: params.id, isphper: params.id
            }, function(data) {
                console.log('获取用户信息成功:::::::', data)
                if(params.cb && typeof(params.cb) == 'function') {
                    params.cb(data);
                }
            })
        },
        getVipActivityInfo({state}) {
            API.getVipActivityInfo({}, function(data) {
                console.log('获取vip限时活动信息成功:::::::', data)
                state.vipActivityInfo = data;
            })
        },
        getVipDayLuckInfo({state}) {
            API.getVipDayLuck({}, (data)=> {
                console.log('获取vip每日抢购活动信息成功:::::::', data);
                state.vipDayLuckType = data.type;
                // 处理数据
                state.vipDayLuckInfo = data.luck;
                state.vipDayLuckInfo.product = Object.assign(data.luck.product, {
                    price: parseFloat(data.luck.product.price/100),
                    rate_price: parseFloat(data.luck.product.rate_price/100),
                });
                state.vipYearUpInfo = data.up;
                state.vipYearUpInfo.product = Object.assign(data.up.product, {
                    price: parseFloat(data.up.product.price/100),
                    rate_price: parseFloat(data.up.product.rate_price/100),
                });
            });
        },
        checkVipYearUpStatus({state, dispatch}) {
            // 如果是年会员升级的话
            console.log('checkVipYearUpStatus----', state.vipDayLuckType);
            if(state.vipDayLuckType != 2) { return; }
            // 跑倒计时
            state.vipYearUpTimeFunc = setTimeout(count, 1000);
            let lsTime = localStorage.getItem('h5_vip_year_up_time_second');
            state.vipYearUpTimeSecond = lsTime && parseInt(lsTime) != 0 ? parseInt(lsTime) : state.vipYearUpTimeSecond;
            function count() {
                state.vipYearUpTimeSecond--;
                window.localStorage.setItem('h5_vip_year_up_time_second', state.vipYearUpTimeSecond);
                state.vipYearUpTimeStr = UTILS.getCountDownTimeStr(state.vipYearUpTimeSecond, 1);
                clearTimeout(state.vipYearUpTimeFunc);
                if(state.vipYearUpTimeSecond > 0) {
                    state.vipYearUpTimeFunc = setTimeout(count, 1000)
                }else if(state.vipYearUpTimeSecond == 0) {
                    // 时间跑完了:再次弹框
                    state.showActDayLuckPop = true;
                    dispatch('updateVipShowEnd');
                }
            }
        },
        updateVipShowEnd({state}) {
            API.upVipShowEnd({}, ()=> {
                console.log('上报VIP时间成功');
            })
        },
        clearUpVipYearUpCountTimeFunc({state}) {
            clearTimeout(state.vipYearUpTimeFunc);
            state.vipYearUpTimeFunc = null;
        },
        submitExportFile({state}, params) {
            API.vipSubmitExport({
                email: params.emailUrl
            }, ()=> {
                console.log('提交导出请求成功');
                if(params.cb && typeof(params.cb) == 'function') {
                    params.cb();
                }
            })
        },
        showMyVipPop({state}, params) {
            state.showMyVip = true;
            state.curSelectPayType = params.vip === 0 ? 10 : params.vip >= 20 ? 30 : 20;
            console.log('showMyVipPop------', params.vip, params.frompage)
            if(params.frompage) {
                switch(params.frompage) {
                    case 'my':
                        MIX.trackPageViewed('ToBeVip', 'me_vip');
                        break;
                    case 'share':
                        MIX.trackPageViewed('ToBeVip', 'no_right_share_bz');
                        break;
                    case 'accept':
                        MIX.trackPageViewed('ToBeVip', 'no_right_accept_bz');
                        break;
                    case 'exportfile':
                        MIX.trackPageViewed('ToBeVip', 'export_to_email_right_now');
                        break;
                    case 'discuss_avt':
                        MIX.trackPageViewed('ToBeVip', 'lunpan_chat_avatar');
                        break;
                    case 'compare_choose':
                        MIX.trackPageViewed('ToBeVip', 'no_right_compare_bz');
                        break;
                    case 'compare_search':
                        MIX.trackPageViewed('ToBeVip', 'search_gz_wx_result_select');
                        break;
                    case 'report_vipbutton':
                        MIX.trackPageViewed('ToBeVip', 'ai_vip_one_click_unlock');
                        break;
                    case 'nature_vipbutton':
                        MIX.trackPageViewed('ToBeVip', 'talent_vip_one_click_unlock');
                        break;
                    default:
                        break;
                }
            }
        },
        confirmBirthday({state}, birthdayData) {
            state.birthdayStr = STRONG_DATA_MANAGER.getSelectedBirthdayStringByData(birthdayData);
            state.strongUserInfo.birthday = STRONG_DATA_MANAGER.getPaiPanParamsBirthday(birthdayData);
            console.log('confirmBirthdayData', birthdayData, state.birthdayStr, state.userInfo.birthday)
        },
        confirmArea({state}, areaArr) {
            state.areaStr = areaArr[0].name == '不选择' ? '' : [areaArr[0].name, areaArr[1].name, areaArr[2].name].join(' ');
            state.strongUserInfo.location = areaArr[0].name == '不选择' ? '' : COLLATE_DATA_MANAGER.getPaiPanParamsLocation(areaArr);
            console.log('confirmArea-----', areaArr, state.areaStr, state.userInfo)
        },
        resetInputData({state}, params) {
            state.areaStr = '';
            state.birthdayStr = '';
            state.strongUserInfo = {
                f_name: '',
                sex: 0,
                birthday: '',
                location: '',
                real_time: 0,
            };
            state.inputData = {
                "unknownTime": params && params.unknownTime ? params.unknownTime : false,
                "isLunar": params && params.isLunar ? params.isLunar : false,
                "year": '', 
                "month": '', 
                "day": '', 
                "hour": '', 
                "minute": ''
            };
        }
    }
}